import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Widget from "csi/gallery/Widget";
import AddPath from "csi/def/AddPath";

const ProductSKUGallery = declare(Widget, {

	buildProductColorGalleryView: function(view, isAllocated) {
		const relationship = view.m_relationship;
		if (!isAllocated) {
			relationship.m_addPaths = [lang.mixin(new AddPath(), {
				m_path: "Child:__Parent__/Child:RealizedProducts",
			})];
			relationship.m_id = "RealizedProducts";
		}
		return view;
	},

	onViewStartBuild: function() {
		const ctx = this.getContext();
		let isAllocated = false;
		let product = this.getViewNode();
		if (product?.$Type === "DataPackage") {
			product = ctx.cache.getNode(product.__Parent__);
		}
		const view = this.defView;
		if (view.m_id === "ProductSKUGalleryWithColorAllocation" && product.ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP") {
			isAllocated = true;
		}
		this.buildProductColorGalleryView(view, isAllocated);
	},
});

export = ProductSKUGallery;